<template>
  <!-- waiting -->
  <div class="flies-step waiting-flies">
    <div class="d-flex mb-2">
      <a
        href="javascript:void(0)"
        class="d-inline-block mr-3"
        @click="cancelSend()"
      >
        <i class="icon-img icon-ms img-outline-back mt-1"></i>
      </a>
      <div>
        <h5 class="mb-1">Waiting...</h5>
        <div class="small">
          Please enter the 6 digital key on the receiving device within
          <strong class="text-primary">{{ formatExpire }}</strong>
        </div>
      </div>
    </div>
    <div class="waiting-code p-3 text-center">
      <h3 class="code">{{ transferKey }}</h3>
      <div class="code-img">
        <img
          :src="
            'http://chart.apis.google.com/chart?chs=100x100&cht=qr&chld=L|0&chl=' +
              transfer.transfer_link
          "
        />
      </div>
    </div>
  </div>
</template>

<script>
import request from "../../../utils/Request";
import swal from "sweetalert";

export default {
  name: "MyWaiting",
  data() {
    return {
      expire: this.transfer.expire,
      myInterval: null,
      isLoading: false
    };
  },
  model: {
    prop: "transfer"
  },
  props: ["transfer"],
  computed: {
    transferKey() {
      return (
        this.transfer.transfer_key.substr(0, 3) +
        " " +
        this.transfer.transfer_key.substr(3, 3)
      );
    },
    formatExpire() {
      let m = parseInt(this.expire / 60).toString();
      m = m.length > 1 ? m : 0 + m;
      let s = parseInt(this.expire % 60).toString();
      s = s.length > 1 ? s : 0 + s;
      return m + ":" + s;
    }
  },
  created() {
    let _self = this;
    /** 倒计时效果*/
    _self.myInterval = setInterval(function() {
      _self.expire--;
      if (_self.expire <= 0) {
        clearInterval(_self.myInterval);
        request({
          url: "/v1/transfer/set-status",
          data: {
            transfer_type: 1,
            id: _self.transfer.id,
            status: 5
          }
        });
        _self.transfer.step = 1;
        swal("The key has expired.");
      }
    }, 1000);
    /** 连接情况轮训*/
    _self.waiting();
  },
  beforeDestroy() {
    let _self = this;
    clearInterval(_self.myInterval);
  },
  methods: {
    waiting() {
      let _self = this;
      if (_self.isLoading || _self.transfer.step !== 3 || _self.expire <= 0) {
        // 非当前组件请求
        return;
      }
      _self.isLoading = true;
      request({
        url: "/v1/transfer/get-status",
        data: {
          transfer_type: 1,
          id: _self.transfer.id
        }
      })
        .then(response => {
          if (response.code === 200 && response.data.status === 1) {
            _self.transfer.step = 4;
            _self.transfer.status = 1;
            _self.transfer.receive_client_name =
              response.data.receive_client_name;
            _self.transfer.host_url = response.data.host_url;
          } else if (response.code === 200 && response.data.status === 7) {
            _self.transfer.step = 6;
          } else if (response.code === 204101) {
            this.transfer.step = 1;
          } else {
            setTimeout(function() {
              _self.waiting();
            }, 2000);
          }
        })
        .finally(() => {
          _self.isLoading = false;
        });
    },
    cancelSend() {
      this.transfer.step = 1;
    }
  }
};
</script>
